import { render, staticRenderFns } from "./FreightCharges.vue?vue&type=template&id=3ba29b98"
import script from "./FreightCharges.vue?vue&type=script&setup=true&lang=js"
export * from "./FreightCharges.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports